/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useShopTicketsStore = defineStore("shoptickets", {
  actions: {
    async listFormFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          txStatus: payload.txStatus,
          shopUid: payload.shopUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async listByShopFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/listbyshop/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async shopTicketsAddFetch(payload) {
      const body = {
        groupUid: payload.groupUid,
        shopUid: payload.shopUid,
        validYear: payload.validYear,
        shopOwner: payload.shopOwner,
        fullname: payload.fullname,
        address: payload.address,
        requestDate: payload.requestDate,
        formDetails: payload.formDetails,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/form/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async shopTicketsUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        groupUid: payload.groupUid,
        shopUid: payload.shopUid,
        validYear: payload.validYear,
        shopOwner: payload.shopOwner,
        fullname: payload.fullname,
        address: payload.address,
        requestDate: payload.requestDate,
        formDetails: payload.formDetails,
        refDocUid: payload.refDocUid,
        approveDate: payload.approveDate,
        txStatus: payload.txStatus,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/form/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async shopTicketsApproveFetch(payload) {
      const body = {
        uid: payload.uid,
        refDocUid: payload.refDocUid,
        approveDate: payload.approveDate,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/form/approve";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async getCoverFormFetch(payload) {
      const body = {
        formUid: payload.formUid,
        shopUid: payload.shopUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/form/cover";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async clearTicketsFetch(payload) {
      const body = {
        shopUid: payload.shopUid,
        validYear: payload.validYear,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/shop-ticket/clear";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
